import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

// project import
import Loadable from 'components/Loadable';
import { WebsocketProvider } from 'contexts/WebsocketContext';
import { ScriptProvider } from 'contexts/ScriptContext';
import { ContactsContextProvider as ContactsProvider } from 'contexts/ContactsContext';

const ScriptsTable = Loadable(lazy(() => import('pages/applications/scriptsTable')));
const ScriptsDetails = Loadable(lazy(() => import('pages/applications/script')));
const ToolsTable = Loadable(lazy(() => import('pages/applications/toolsTable')));

// ==============================|| APPS ROUTING ||============================== //

const ApplicationsRoutes = {
  path: '/',
  element: (
    <WebsocketProvider>
      <ContactsProvider>
        <Outlet />
      </ContactsProvider>
    </WebsocketProvider>
  ),
  children: [
    {
      path: 'scripts',
      element: (
        <ScriptProvider>
          <ScriptsTable />
        </ScriptProvider>
      )
    },
    {
      path: 'scripts/:id',
      element: (
        <ScriptProvider>
          <ScriptsDetails />
        </ScriptProvider>
      )
    },
    {
      path: 'tools',
      element: <ToolsTable />
    }
  ]
};

export default ApplicationsRoutes;
